import React, { Component } from 'react';

import TOOLS from '../../componentes/TOOLS';

import '../css/Login.css';

class Login extends Component {
    constructor() {
        super();
        this.state = {

            user : "",
            password : ""
        };
    }

    login() {
        const form = new FormData()
        form.append('user', this.state.user);
        form.append('password', this.state.password);

        fetch(`${TOOLS.serverURL}/login/`, {
            method: "POST",
            body: form
        })
        .then(response => response.json())
        .then(json => {
            if (json.ok) {
                window.localStorage.setItem("AUTH-X-TOKEN", json.token);
                this.props.callbackLogin(true);
            } else {
                window.alert("Falha ao autenticar-se!!!");
            }
        });
    }

    handleSubmit(e){
        e.preventDefault();
        this.login();
    }

    handleChange(e) {
        let obj = {};
        obj[e.target.name] = e.target.value;
        this.setState({ ...obj });
    }

    componentWillMount() {
   
    }

    render() {
        return (
            <form action="/" className="card" id="login-form" onSubmit={this.handleSubmit.bind(this)} >
                <div className="card-title">Login</div>
                <div id="login-content">
                    <div className="form-container">
                        <label htmlFor="user">User</label>
                        <input type="text" name="user" id="user" onChange={this.handleChange.bind(this)} />
                    </div>
                    <div className="form-container">
                        <label htmlFor="password">Password</label>
                        <input type="password" name="password" id="password" onChange={this.handleChange.bind(this)} />
                    </div>
                    <div className="form-container">
                        <button type="submit" className="btn btn-primary">Go!</button>
                        <button type="button" className="btn btn-default">Cancel</button>
                    </div>
                </div>
            </form>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/adm/componentes/Login.js